(function() { window.GUID_d2876d2d_17ee_4f65_aa9f_63c697dd3dee = { getGuid: function() { return "d2876d2d-17ee-4f65-aa9f-63c697dd3dee"; } }; })();
var KeyCode;
(function (KeyCode) {
    KeyCode[KeyCode["Enter"] = 13] = "Enter";
    KeyCode[KeyCode["Escape"] = 27] = "Escape";
    KeyCode[KeyCode["SpaceBar"] = 32] = "SpaceBar";
    KeyCode[KeyCode["ArrowUp"] = 38] = "ArrowUp";
    KeyCode[KeyCode["ArrowDown"] = 40] = "ArrowDown";
    KeyCode[KeyCode["ArrowLeft"] = 37] = "ArrowLeft";
    KeyCode[KeyCode["ArrowRight"] = 39] = "ArrowRight";
    KeyCode[KeyCode["Add"] = 107] = "Add";
    KeyCode[KeyCode["Plus"] = 107] = "Plus";
    KeyCode[KeyCode["Subtract"] = 109] = "Subtract";
    KeyCode[KeyCode["Minus"] = 109] = "Minus";
})(KeyCode || (KeyCode = {}));

//# sourceMappingURL=KeycodeEnum.js.map
